// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {readPipDetails} from './get-pip-details';

export const updatePipDetails = pipId =>

    dispatch => {

        if (pipId) {

            readPipDetails(pipId, false)(dispatch);

        } else {

            dispatch({
                type: actions.RESET_CLAIM_PIP_PIP_DETAILS
            });

            dispatch({
                partNumber: '',
                type: actions.UPDATE_CLAIM_PIP_FAILURE_PART
            });

        }

    };



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/update-pip-details.js